import { render, staticRenderFns } from "./BoxAgenda.vue?vue&type=template&id=5f3c4dca&"
import script from "./BoxAgenda.vue?vue&type=script&lang=js&"
export * from "./BoxAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports